import React from 'react';
import { observer } from "mobx-react-lite";
import type { KnownTracker } from "../../../lib/KnownTrackers";
import { styled } from "styled-components";

export const TrackerLineElement = styled.div`
	margin-left: 0.1rem;
	font-size: 90%;
`;
export const TrackerDbNameSpan = styled.span`
	color: rgba(64, 0, 32, 1);
`;
export const TrackerOrgNameSpan = styled.span`
	color: rgba(54, 0, 0, 1);
`;


export const KnownTrackerView = observer(({ knownTracker }: { knownTracker?: KnownTracker; }) => {
	if (knownTracker == null) return null;
	const { organizationKnownAs, ghosteryId, ghosteryOrganizationName, whenAddedToGhostery, disconnectMeName, whenAddedToDisconnectMe
	} = knownTracker;
	return (<>
		{disconnectMeName != null && whenAddedToDisconnectMe != null ? (<TrackerLineElement>
			<TrackerDbNameSpan>DisconnectMe</TrackerDbNameSpan>&#32; added as&#32;
			<TrackerOrgNameSpan>{disconnectMeName}</TrackerOrgNameSpan>
			{whenAddedToDisconnectMe === "2015-10-13T19:06:27.000Z" ? " in its initial database (Oct 13, 2015)" :
				` on ${new Date(whenAddedToDisconnectMe).toLocaleDateString("en", { month: 'short', day: 'numeric', year: 'numeric' })}`}
		</TrackerLineElement>) : null}
		{ghosteryId != null && ghosteryOrganizationName != null && whenAddedToGhostery != null ? (<TrackerLineElement>
			<TrackerDbNameSpan>Ghostery</TrackerDbNameSpan>&#32; added as&#32;<TrackerOrgNameSpan>{ghosteryOrganizationName}</TrackerOrgNameSpan>&#32;(ID: {ghosteryId}) {whenAddedToGhostery === "2023-02-20T19:33:05.000Z" ? " in its initial database (Feb 20, 2023)" :
				` on ${new Date(whenAddedToGhostery).toLocaleDateString("en", { month: 'short', day: 'numeric', year: 'numeric' })}`}
		</TrackerLineElement>) : null}
	</>);
});
